<template>
	<div class="mt-8">
	  <div class="shopping-cart-empty-t big animate__animated animate__fadeIn">
		<center>
		  <img class="tr-banner-select-day"
			src="https://storage.googleapis.com/gx-global-cms/events/46f83203-d9ba-471e-af78-7a3d4716f9d5.jpeg" alt="" />
		</center>
		<div class="tr-select-day">
		  <div class="tr-logo-png"><img src="https://www.triatlonxelha.com/logos/triatlonlogo.png" /></div>
		  <div class="tr-content-inf">
			<br /><br />
			<span class="tr-text-select-date">{{ $t("triatlon.text_select_date") }}</span>
			<br /><br /> <br />
			<div class="tr-select-day-buttons">
			  <button @click="payPhotoPass(0)" type="button"
				class="rounded-full py-3 text-sm p-3 border-yellow-photo cursor-pointer font-semibold tr-button-day">{{
				  formatDateString(0) }}
			  </button>
			  <button @click="payPhotoPass(1)" type="button"
				class="rounded-full py-3 text-sm p-3 border-yellow-photo cursor-pointer font-semibold tr-button-day">{{
				  formatDateString(1) }}
			  </button>
			</div>
		  </div>
		</div>
	  </div>
	</div>
  </template>
  <script>
import moment from "moment";
import Currencies from "../logic/payment/Currency.js";

export default {
	data: () => ({
		eventDetails: {},
		currentDates: [],
		requestEvent: {
			EventId: "08742d7a-f0fc-11ef-99f0-0affeb88"
		}
	}),
	props: [],
	mixins: [],
	components: {},
	computed: {},
	methods: {
		/**
		 * Function to add date to the shopping cart for the triatlón service
		 * @param numberDate 
		 * @returns redirects to the payment component
		 */
		payPhotoPass(numberDate) {
			this.$store.state.competitionOn = this.currentDates[numberDate];

			this.$store.dispatch("setAlbumTRT", this.eventDetails).then((data) => {
				this.$router.push({ name: "payment" });
			});
		},
		/** 
		 * Function to give format to date depending the language
		 * @param numberDate 
		 * @returns {string}
		 */
		formatDateString(numberDate) {
			const lang = this.$store.state.Language;
			let format = lang == 'es' ? 'dddd, D [ de] MMMM' : 'dddd, MMMM D';
			let photoPassDayValue = this.currentDates[numberDate];
			let dateString = moment(photoPassDayValue).locale(lang).format(format);

			return dateString;
		},
		/**
		 * Obtains the date making the requst to getEventDetails
		 * @returns the event dates
		 */
		async getEventDate() {
			try {
				this.$store.dispatch("setLoading", true);
				this.$store.dispatch("clearShoppingCart");
				const response = await this.$store.dispatch("getEventDetails", this.requestEvent);
				this.eventDetails = response;
				this.currentDates = response.Dates;
			} catch (error) {
				this.$store.dispatch("setLoading", false);
			} finally {
				this.$store.dispatch("setLoading", false);
			}
		},
	},
	async created() { 
		await this.getEventDate();
	}
}
  </script>